export const MarketingEventsProductsGridPluginSettings: IPluginSettings = {
    name: 'Товары маркетинговых мероприятий',
    mnemocode: 'marketing_events_products_plugin',
    permission: 'MarketingEvents',
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'idGlobal',
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'idMarketingEventGlobal',
                propertyType: 'string',
                displayName: 'ID маркетингового мероприятия',
                visibility: true,
                width: 300
            },
            {
                order: index++,
                propertyName: 'code',
                propertyType: 'string',
                displayName: 'Код товара',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'goodsName',
                propertyType: 'string',
                displayName: 'Товар',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'producerName',
                propertyType: 'string',
                displayName: 'Производитель',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'guidEs',
                propertyType: 'string',
                displayName: 'GUID товара ЕС',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'priority',
                propertyType: 'number',
                displayName: 'Приоритет товара',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'message',
                propertyType: 'string',
                displayName: 'Ключевая фраза',
                visibility: true,
                width: 200
            },
            {
                order: index++,
                propertyName: 'quantityPlan',
                propertyType: 'number',
                displayName: 'План товара',
                visibility: true,
                width: 120
            },
            {
                order: index++,
                propertyName: 'priceRef',
                propertyType: 'number',
                displayName: 'Референтная цена товара',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'bonusMember',
                propertyType: 'number',
                displayName: 'Бонус участнику',
                visibility: true,
                width: 140
            },
            {
                order: index++,
                propertyName: 'matrixCategoryType',
                propertyType: 'number',
                displayName: 'Тип ассортимента АП',
                visibility: true,
                width: 180
            },            
            {
                order: index++,
                propertyName: 'deleted',
                propertyType: 'boolean',
                displayName: 'Удален',
                visibility: false,
                width: 100
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: false,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: false,
                width: 150
            },
            
        ];
    })()
};